/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_AdvancedInputs */

const cs_filter_advanced = /** @type {(inputs: Filter_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokročilé filtry`)
};

const en_filter_advanced = /** @type {(inputs: Filter_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced filters`)
};

/**
* | output |
* | --- |
* | "Advanced filters" |
*
* @param {Filter_AdvancedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_advanced = /** @type {((inputs?: Filter_AdvancedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_AdvancedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_advanced(inputs)
	return cs_filter_advanced(inputs)
});